<template>
    <div class="cartwrapper">
        <div>homchoo</div>
        <hr />
        <div class="phonetotal">
            <div class="phonecartwrapper">
                <div data-radium="true">
                    訂單總金額：{{ billTotalAmount | currency }}
                    <div class="cartButton" data-radium="true">
                        <button
                            type="button"
                            class="ant-btn"
                            onclick="showCartList()"
                        >
                            <span>購物車</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="shopSelect">購物方式</label>
            <select
                class="form-control"
                id="paySelect"
                style="color: #bfbfbf"
                oninput='style.color="black"'
            >
                <option style="display: none">付款方式</option>
                <option class="option" style="color: rgba(0, 0, 0, 0.65)">
                    ATM
                </option>
                <option style="color: rgba(0, 0, 0, 0.65)">貨到付款</option>
                <option style="color: rgba(0, 0, 0, 0.65)">信用卡結帳</option>
            </select>
        </div>
        <div class="form-group">
            <select
                class="form-control"
                id="shipSelect"
                style="color: #bfbfbf"
                oninput='style.color="black"'
            >
                <option style="display: none">運送方式</option>
                <option style="color: rgba(0, 0, 0, 0.65)">宅配到府</option>
                <option style="color: rgba(0, 0, 0, 0.65)">超商取貨</option>
            </select>
        </div>
        <!--
		<div class="input-group mb-3">
			<input
				type="text"
				class="form-control"
				placeholder="請輸入優惠碼"
				style="color: #bfbfbf"
			/>
            <div class="input-group-append">
				<button class="btn btn-outline-secondary" type="button">
					確認折抵
				</button>
			</div>
		</div>
        -->
        <br />
        <user-profile-order></user-profile-order>
        <div class="form-group">
            <label for="" style="display: inline-block">收件人資料</label>
            <div class="form-check float-right">
                <input
                    class="form-check-input"
                    type="checkbox"
                    name="remember"
                    id="remember"
                />
                <label class="form-check-label" for="remember">
                    同會員資料
                </label>
            </div>
            <input
                type="text"
                class="form-control"
                id="name2"
                placeholder="姓名"
            />
            <input
                type="text"
                class="form-control"
                id="phone2"
                placeholder="手機"
            />
            <input
                type="text"
                class="form-control"
                id="area"
                placeholder="地區"
            />
            <input
                type="text"
                class="form-control"
                id="address"
                placeholder="地址"
            />
            <select
                name=""
                id=""
                class="form-control"
                style="color: #bfbfbf; margin-bottom: 10px"
                oninput='style.color="black"'
                onchange="chg(this)"
            >
                <option style="display: none">電子發票</option>
                <option style="color: rgba(0, 0, 0, 0.65)">會員載具</option>
                <option value="-1" style="color: rgba(0, 0, 0, 0.65)">
                    手機載具
                </option>
                <option value="1" style="color: rgba(0, 0, 0, 0.65)">
                    公司戶
                </option>
            </select>
            <input
                type="text"
                class="form-control"
                id="phonecode"
                placeholder="請輸入手機條碼"
                style="display: none"
            />
            <div id="cpinvoice" style="display: none">
                <div style="display: flex">
                    <div style="margin-right: 2%; width: 49%">
                        <input
                            type="text"
                            class="form-control"
                            id=""
                            placeholder="發票抬頭"
                        />
                    </div>
                    <div style="margin-left: 5px; width: 49%">
                        <input
                            type="text"
                            class="form-control"
                            id=""
                            placeholder="統一編號"
                        />
                    </div>
                </div>
                <input
                    type="text"
                    class="form-control"
                    id=""
                    placeholder="發票寄送地址"
                />
            </div>
            <textarea
                name=""
                id=""
                rows="4"
                placeholder="訂單備註"
                style="
                    width: 100%;
                    resize: none;
                    border: 1px solid #ccc;
                    outline: none;
                    padding: 10px;
                "
            ></textarea>
        </div>
        <div class="checkoutbtnroot">
            <div class="ctshopping"><a :href="previousUrl">繼續購物</a></div>
            <div class="phonecfsd">
                <button class="confirmsd btn">確認送出</button>
            </div>
        </div>
    </div>
</template>
<script>
    import ComponentBaseVue from "../../ComponentBase.vue";
    import CartListBaseVue from "../Carts/CartListBase.vue";
    export default {
        mixins: [ComponentBaseVue],
        extends: CartListBaseVue,
        props: {
            previousUrl: {
                default: base_url,
            },
        },
        data() {
            return {
                logisticsAmount: 0,
                couponAmount: 0,
            };
        },
        computed: {
            billTotalAmount() {
                return (
                    this.cartTotalAmount + this.logisticsAmount - this.couponAmount
                );
            },
            cartTotalAmount: CartListBaseVue.computed.totalAmount,
        },
    };
</script>
<style lang="">
</style>